export default __webpack_public_path__ + "static/media/Factory_Factory-Integration.b589f67d.mp4";